import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, ArrowRight, CheckCircle2 } from "lucide-react";

export const CTASection = () => {
  const benefits = [
    "Free on-site consultation",
    "Detailed written quotes",
    "Fire-rated certification",
    "Competitive commercial rates",
  ];

  return (
    <section className="py-16 lg:py-24 bg-white" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-2xl overflow-hidden">
          {/* Background */}
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1649510777971-eef1cdb3e6d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxnb2xkJTIwY29hc3QlMjBhdXN0cmFsaWElMjBza3lsaW5lJTIwbW9kZXJuJTIwaGlnaCUyMHJpc2UlMjBidWlsZGluZ3xlbnwwfHx8fDE3NzE0Nzc5Njd8MA&ixlib=rb-4.1.0&q=85"
              alt="Gold Coast skyline"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#0F172A]/90"></div>
          </div>

          {/* Content */}
          <div className="relative z-10 py-16 px-8 lg:py-20 lg:px-16">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Left Column */}
              <div>
                <span className="inline-block text-[#F59E0B] font-medium text-sm uppercase tracking-wider mb-4">
                  Ready to Start?
                </span>
                <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white uppercase mb-6 leading-tight">
                  Get Your Free Quote Today
                </h2>
                <p className="text-slate-300 text-lg mb-8 leading-relaxed">
                  Whether you're a builder working on a commercial project or a homeowner 
                  needing caulking services, we're here to help. Contact us for a free 
                  consultation and detailed quote.
                </p>

                {/* Benefits */}
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                  {benefits.map((benefit, index) => (
                    <li key={index} className="flex items-center gap-3 text-slate-300">
                      <CheckCircle2 className="w-5 h-5 text-[#F59E0B] flex-shrink-0" />
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Buttons */}
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link to="/quote">
                    <Button
                      size="lg"
                      className="bg-[#F59E0B] hover:bg-[#D97706] text-[#0F172A] font-heading font-bold uppercase tracking-wide px-8"
                      data-testid="cta-get-quote-btn"
                    >
                      Request a Quote
                      <ArrowRight className="ml-2 w-5 h-5" />
                    </Button>
                  </Link>
                  <a href="tel:+61412345678">
                    <Button
                      size="lg"
                      variant="outline"
                      className="border-2 border-white text-white hover:bg-white hover:text-[#0F172A] font-heading font-bold uppercase tracking-wide px-8 bg-transparent"
                      data-testid="cta-call-btn"
                    >
                      <Phone className="mr-2 w-5 h-5" />
                      Call Us Now
                    </Button>
                  </a>
                </div>
              </div>

              {/* Right Column - Contact Card */}
              <div className="bg-white rounded-xl p-8 shadow-2xl">
                <h3 className="font-heading text-xl font-bold text-[#0F172A] uppercase mb-6">
                  Quick Contact
                </h3>
                <div className="space-y-6">
                  <div>
                    <p className="text-slate-500 text-sm mb-1">Phone</p>
                    <a href="tel:+61435825379" className="text-[#0F172A] text-xl font-medium hover:text-[#F59E0B] transition-colors">
                      0435 825 379
                    </a>
                  </div>
                  <div>
                    <p className="text-slate-500 text-sm mb-1">Email</p>
                    <a href="mailto:danny@gappro.com.au" className="text-[#0F172A] text-xl font-medium hover:text-[#F59E0B] transition-colors">
                      danny@gappro.com.au
                    </a>
                  </div>
                  <div>
                    <p className="text-slate-500 text-sm mb-1">Service Area</p>
                    <p className="text-[#0F172A] text-lg">Gold Coast & South East Queensland</p>
                  </div>
                  <div>
                    <p className="text-slate-500 text-sm mb-1">Business Hours</p>
                    <p className="text-[#0F172A]">Monday - Friday: 6:30am - 5pm</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
